<template>
  <div>
    <v-layout justify-center column>
      <h1 class="text-center">Para a segurança de todos, preencha abaixo quem são as pessoas que podem retirar o aluno da escola.</h1>
      <v-divider class="divider-accent my-4" />
    </v-layout>

    <v-card>
      <v-flex pa-4>

        <v-layout justify-center column>
          <h2 class="mb-2 text-center">Ao preencher este formulário, você estará autorizando as pessoas indicadas abaixo a retirarem o aluno da escola ao término das aulas.</h2>
          <h3 class="mb-2 text-center text-secondary">By filling this form, you will allow the people indicated below to pick-up your child at school after class</h3>
          <v-divider class="divider-primary mb-4"/>
        </v-layout>

        <add-header @click="openModal" class="mb-4">
          <template slot="title">
            <h2>Autorizados para retirada</h2>
            <h3 class="text-secondary">Authorized for withdrawal</h3>
          </template>
        </add-header>
        <load-form-handler
          :promise="getReponsibles"
          v-model="responsibles"
          placeholder>

          <template v-for="(responsible_student, index) in responsibles">
            <form-authorized-responsible
              :responsible_students_attributes="responsible_student"
              :key="responsible_student.id"
              readonly
            />

            <v-layout row :key="index+'button-wrapper'" wrap justify-center>
              <v-btn
                :key="index+'edit_button'"
                fab color="primary" dark
                @click="openModal(responsible_student.id)">
                  <v-icon dark>edit</v-icon>
              </v-btn>

              <v-btn
                :key="index+'delete_button'"
                fab color="primary"
                @click="openAlertModal(responsible_student.id)">
                  <v-icon dark>delete</v-icon>
              </v-btn>
            </v-layout>

            <v-divider v-if="index !== (responsibles.length -1)" :key="index+'divider'" class="my-4"/>
          </template>
        </load-form-handler>

      </v-flex>
    </v-card>

    <modal-form
      title="Autorizado de retirada / Authorized withdrawal"
      :visibility="modalVisibility"
      @onClose="closeModal"
      @onSave="onSaveModal"
      id="modal-form-responsible">
        <form-authorized-responsible
          ref="authorized_responsible_form"
          :responsible_id="responsibleStudentId"
          @responsible_students_attributes="handleSaveForm"
        />
    </modal-form>

    <alert-modal
      :visibility="alertModalVisibility"
      title="Excluir registro"
      message="Tem certeza que deseja excluir o registro?"
      confirmAction="OK"
      cancelAction="CANCELAR"
      @confirm="removeResponsible"
      @cancel="closeAlertModal"/>
  </div>
</template>

<script>
import * as api from '@/api'
import FormAuthorizedResponsible from './FormAuthorizedResponsible'
import ModalForm from '@/components/ModalForm'
import AddHeader from '@/components/AddHeader'
import LoadFormHandler from '@/components/LoadFormHandler'
import { mapActions } from 'vuex'
import AlertModal from '@/components/AlertModal'
import { formTabs, message } from '@/mixins'

/**
 * @group Form
 * Component responsável pela lista de autorizados a retirada da criança
 */
export default {
  name: 'FormResponsibleStudents',

  data: () => ({
    isFormLoading: false,
    formError: false,
    responsibles: [],
    modalVisibility: false,
    selectedResponsible: {},
    responsibleStudentId: null,
    alertModalVisibility: false
  }),

  components: {
    FormAuthorizedResponsible,
    ModalForm,
    AddHeader,
    LoadFormHandler,
    AlertModal
  },

  mixins: [formTabs, message],

  computed: {
    currentStudentId () {
      return this.$route.params.id
    }
  },

  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack',
      showMessageQueue: 'snackbar/showMessageQueue'
    }),

    getReponsibles () {
      return api.responsible.student.get(this.currentStudentId)
    },

    openModal (id = null) {
      this.responsibleStudentId = id
      this.modalVisibility = true
    },

    closeModal () {
      this.responsibleStudentId = null
      this.modalVisibility = false
    },

    onSaveModal () {
      this.$refs.authorized_responsible_form.save()
    },

    async handleSaveForm (responsible) {
      try {
        if (this.responsibleStudentId) {
          const { data } = await api.responsible.student.update(this.currentStudentId, this.responsibleStudentId, responsible)
          this.responsibles[this.responsibles.findIndex(r => r.id === this.responsibleStudentId)] = data
          this.$forceUpdate()
          this.showMessageByType(this.messageTypes.MODIFIED)
        } else {
          const { data } = await api.responsible.student.create(this.currentStudentId, responsible)
          this.responsibles.push(data)
          this.showMessageByType(this.messageTypes.CREATED)
        }
      } catch (error) {
        switch (error.response.status) {
          case 422: {
            this.showMessageQueue(error.response.data.full_messages)
            break
          }

          default: {
            this.showMessageByType(this.messageTypes.ERROR)
            break
          }
        }
      } finally {
        this.closeModal()
      }
    },

    removeResponsible () {
      api.responsible.student.remove(this.currentStudentId, this.responsibleStudentId).then(() => {
        this.responsibles.splice(this.responsibles.findIndex(r => r.id === this.responsibleStudentId), 1)
        this.showMessageByType(this.messageTypes.REMOVAL)
        this.closeAlertModal()
      }).catch(() => {
        this.showSnack('Occoreu um erro, tente novamente.')
      })
    },

    openAlertModal (id) {
      this.responsibleStudentId = id
      this.alertModalVisibility = true
    },

    closeAlertModal () {
      this.responsibleStudentId = null
      this.alertModalVisibility = false
    }
  }
}
</script>
